import React, {Component} from "react";
import {Redirect } from 'react-router-dom';
import {FaSignInAlt, FaLock, FaUser, FaEye} from "react-icons/fa";
import {Row, Col, Form, Button, Spinner} from "react-bootstrap";

import Message from '../extension/Message'
import _ from '../lib/Var'
import C from '../lib/Config';
import swal from 'sweetalert';

function passwordShow() {
    var x = document.getElementById("myInput");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
}
export default class Login extends Component {
    constructor(props) {
      super(props)
      this.state = {
        ToDashboard: false, username: '', password: '', LogingIn: false, Messages: [], errors: {}
      }
      this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        const wasSessionEnding = localStorage.getItem('session_ending');
        const wasRefreshing = sessionStorage.getItem('reloading');

        if (wasSessionEnding) {
            localStorage.removeItem('session_ending');
            sessionStorage.removeItem('reloading');
            if (!wasRefreshing && localStorage.getItem('jwttoken')) {
                // Tab was closed — call deferred logout
                fetch(C.getUrl() + '/login/logout', { method: 'POST' }).catch(() => {});
                localStorage.clear();
                return;
            }
        }

        const msg = sessionStorage.getItem('logoutMessage');
        if (msg) {
            sessionStorage.removeItem('logoutMessage');
            swal({ title: "Logged Out", text: msg, icon: "info", buttons: false, timer: 3000 });
        }
    }

    validateForm(){
      let formIsValid = true;
      let errors = {};
      let state = this.state;
      if(state.username ==="" || state.username.length<=0){
        errors["username"] = "Email address cannot be empty";
        formIsValid= false;
      }
      if(state.username !== "undefined"){
          let lastAtPos = state.username.lastIndexOf('@');
          let lastDotPos = state.username.lastIndexOf('.'); 
          if (!(lastAtPos < lastDotPos && lastAtPos > 0 && state.username.indexOf('@@') === -1 && lastDotPos > 2 && (state.username.length - lastDotPos) > 2)) {
            formIsValid = false;
            errors["username"] = "Please enter valid email address";
          }
      }
      if(state.password ==="" || state.password.length<=0){
        errors["password"] = "Password cannot be empty";
        formIsValid= false;
      }
      this.setState({errors: errors});
      return formIsValid;
    }

    handleChange(event){
      if(event.target.name === 'username'){
        this.state.errors["username"] ="";
        this.setState({username: event.target.value});
      }
      if(event.target.name === 'password'){
        this.state.errors["password"] ="";
        this.setState({password: event.target.value});
      }
    }

    _handleSubmit(e) {
      e.preventDefault()
      let isThisValidForm = false;
      if(this.validateForm()){
          isThisValidForm = true;
      }

      if(isThisValidForm){
        this.setState({LogingIn: true, Messages: []})
        return fetch(C.getUrl() + '/login/authenticateUser', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(this.state),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
          let resObj = res;
          let error = resObj.subErrors;
          if (error !== 'undefined' && error !== null && error !== "") {
            swal({ title: "Warning!",  text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
            this.setState({
              LogingIn: false,
              Messages: _.get(res, 'subErrors', [])
            });
          } else {
            let obj = JSON.parse(resObj.message);
            if (obj.userId !== null && obj.userId !== 0) {
              localStorage.setItem('userId', obj.userId);
              localStorage.setItem('username', obj.username);
              localStorage.setItem('firstName', obj.firstName);
              localStorage.setItem('lastName',obj.lastName);
              localStorage.setItem('activeInd', obj.activeInd);
              localStorage.setItem('userRoleDto', JSON.stringify(obj.userRoleDto));
              localStorage.setItem('associatedDocDto', obj.associatedDocDto?JSON.stringify(obj.associatedDocDto):"");
              localStorage.setItem('profilePictureData', obj.profilePictureData);
              localStorage.setItem('jwttoken',obj.token);
              this.setState({ToDashboard: true, LogingIn: false})
            }
          }
        })
        .catch(err => {
          swal({ title: "Warning!",  text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
      }
    }

    _renderMessages() {
      const {Messages} = this.state
      swal({ title: "Warning!",  text: "Messages :" + Messages, icon: "error", buttons: false, timer: 2000, });
      return (
        <div>
          {typeof Messages !== 'undefined' && Messages.length > 0 && (
            <div className='mb-2'>
              {Messages.map(el => (
                <Message data={el} key={el.Code} />
              ))}
            </div>
          )}
        </div>
      )
    }
    render() {
      if (this.state.ToDashboard === true) {
        return <Redirect to='dashboard' />
      }
  
      return (
        <div id="page-login" className='h100 form-body'>
            <Row>
                <Col lg='7' className="pl-0 pr-0"><div className="bg-image"></div></Col>
                <Col lg='5' className="pl-0 pr-0">
                    <div className="form-holder">
                        <div className="form-content">
                            <div className="form-items">
                                <h3 className="text-center w-100">LOGIN</h3>
                                <Form onSubmit={e => this._handleSubmit(e)} className="form" noValidate>
                                    <Form.Group className="input-group">
                                        <span className="input-group-addon"><FaUser className='' /></span>
                                        <Form.Control id="email" type="email" placeholder='Email Address' name="username" onChange={this.handleChange} />
                                        <div className="invalid-feedback">{this.state.errors["username"]}</div>
                                    </Form.Group>
                                    <Form.Group className='input-group'>
                                        <span className="input-group-addon"><FaLock className='' /></span>
                                        <Form.Control id="myInput" type='password' name="password" placeholder='Password' onChange={this.handleChange} />
                                        <span className="input-group-addon" style={{backgroundColor: "#e8f0fe"}}><FaEye className='' onClick={passwordShow} /></span>
                                        <div className="invalid-feedback">{this.state.errors["password"]}</div>
                                    </Form.Group>
                                    <div className="form-button text-center">
                                        <Button className="btn btn-info" type='submit'>
                                            {this.state.LogingIn && (
                                                <Spinner className='mr-3' animation='border' size='1.5rem'/>
                                            )}
                                            {!this.state.LogingIn && (
                                                <FaSignInAlt className='mr-2' size='1.5rem' style={{verticalAlign: "text-bottom"}} />
                                            )}
                                            Login
                                        </Button>
                                    </div>
                                </Form>
                                <div className="form-button" style={{marginTop: "28px"}}>
                                    <a href="#/forgotPassword" className="pull-right">Forgot password?</a>
                                    <span>New Here ? <a href="#/Register">Sign Up</a></span>
                                </div>
                                {/* <div className="form-button text-center">
                                    <p>&#169; 2021 Onco Consultancy Services. All rights reserved.</p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
      )
    }
}